module.exports = __webpack_public_path__ + "img/wl_sl1.2109ebb9.jpg";